module.exports = __webpack_public_path__ + "static/media/icon-plan.665890e9.svg";